import { render, staticRenderFns } from "./math.vue?vue&type=template&id=5152c6a6&"
import script from "./math.vue?vue&type=script&lang=js&"
export * from "./math.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports